
import required from './required';

// Returns a percentage number based on given start, end and position numbers.
// Make sure the start is not a negative value. Use offset() if you need it.
export default function percentage(start = required(), end = required(), position = required()) {
  return ((position - start) / (end - start)) * 100;
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/modules/percentage.js